import { createSelector } from '@ngrx/store';
import { addressProviderState } from '../root';

export const getAddressProviderPlaces = (search: string) =>
    createSelector(addressProviderState, (addressProvider) => addressProvider?.places.filter((place) => place.hasSucceeded && place.data?.length && place.search === search) ?? []);
